import React, { useLayoutEffect, useState } from 'react'
import api from './api'
import '../css/useragreement.css'


import { Alert, message, Tag, Typography, Table } from 'antd'

import { ProCard } from '@ant-design/pro-components'

const { Text, Title, Link } = Typography


//  用户协议布局
function UserAgreement(props) {
    const [isAgreed, setIsAgreed] = useState(false);
    const [currentSection, setCurrentSection] = useState('all');

    const sections = [
        { id: 'intro', title: '一、引言' },
        { id: 'account', title: '二、账号注册与管理' },
        { id: 'behavior', title: '三、用户行为规范' },
        { id: 'payment', title: '四、充值、会员与退款条款' },
        { id: 'privacy', title: '五、隐私与个人信息保护' },
        { id: 'ip', title: '六、知识产权声明' },
        { id: 'liability', title: '七、免责与责任限制' },
        { id: 'modification', title: '八、协议修改与终止' },
        { id: 'dispute', title: '九、争议解决' }
    ];

    return (
        <div className="user-agreement-container">
            <header className="agreement-header">
                {/* <div className="logo-container">
                    <div className="logo">N2YUN</div>
                    <span className="logo-text">社区</span>
                </div> */}
                <h1>N2YUN社区用户协议</h1>
                <div className="header-info">
                    <p>生效日期：2025年6月21日</p>
                </div>
                <div className="header-info">
                    <p>最后更新：2025年6月21日</p>
                </div>
            </header>

            <div className="agreement-content">
                {/* <div className="navigation-sidebar">
                    <h3>协议导航</h3>
                    <ul>
                        {sections.map(section => (
                            <li
                                key={section.id}
                                className={currentSection === section.id ? 'active' : ''}
                                onClick={() => setCurrentSection(section.id)}
                            >
                                {section.title}
                            </li>
                        ))}
                        <li
                            className={currentSection === 'all' ? 'active' : ''}
                            onClick={() => setCurrentSection('all')}
                        >
                            查看完整协议
                        </li>
                    </ul>

                    <div className="legal-references">
                        <h4>相关法规依据</h4>
                        <ul>
                            <li>《中华人民共和国个人信息保护法》</li>
                            <li>《互联网用户账号名称管理规定》</li>
                            <li>《网络交易管理办法》</li>
                            <li>《网络安全法》</li>
                        </ul>
                    </div>
                </div> */}

                <div className="agreement-text">
                    {(currentSection === 'all' || currentSection === 'intro') && (
                        <section id="intro">
                            <h2>一、引言</h2>
                            <p>欢迎注册并使用N2YUN社区（下称"本平台"）。</p>
                            <p>本协议是用户（下称"您"）与运营方之间的法律契约，规范您对社区论坛功能的使用。<strong>请务必仔细阅读</strong>。注册即视为您同意本协议。</p>
                            <p><strong>N2YUN社区有权随时对用户协议进行修改（修改包含变更、增加、减少相应的协议内容），一旦用户协议发生修改，N2YUN社区将在相关页面进行更新展示</strong>。如果您不同意本协议的修改，可以停止对本服务的使用。您继续使用N2YUN社区提供的服务，则视为您已经接受本协议的全部修改。</p>
                        </section>
                    )}

                    {(currentSection === 'all' || currentSection === 'account') && (
                        <section id="account">
                            <h2>二、账号注册与管理</h2>
                            <h3>1. 注册资格</h3>
                            <ul>
                                <li><strong>如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人（以下简称“监护人”）的陪同下阅读和判断是否同意本协议；</strong></li>
                                <li>需提供<strong>真实有效的手机号</strong>并通过验证，否则无法进行发布内容、评论或购买资源；</li>
                                {/* <div className="legal-reference">依据《互联网用户账号名称管理规定》第五条，用户需实名认证。</div> */}
                            </ul>

                            <h3>2. 手机号绑定要求</h3>
                            <ul>
                                <li><strong>发布资源、发帖、评论前必须绑定手机号</strong>，验证方式包括短信验证码；</li>
                                <li>绑定的手机号<strong>不可随意更改</strong>。</li>
                                {/* <li>境外用户无内地手机号需联系客服处理。</li> */}
                            </ul>

                            <h3>3. 账号安全</h3>
                            <ul>
                                <li>您需妥善保管账号密码，所有使用该账号的操作视为您本人行为；</li>
                                <li>为保护您的帐号安全，您应当妥善保管您的帐号信息，因您保管不善可能导致遭受盗号或密码失窃，责任及由此造成的损失由您自行承担。</li>
                            </ul>
                        </section>
                    )}

                    {(currentSection === 'all' || currentSection === 'behavior') && (
                        <section id="behavior">
                            <h2>三、用户行为规范</h2>
                            <h3>1. 内容发布责任</h3>
                            <ul>
                                <li>您发布的帖子、评论、资源需遵守法律法规，禁止包含：
                                    <ul>
                                        <li>反对宪法所确定的基本原则的；</li>
                                        <li>危害国家安全、泄露国家机密，颠覆国家政权，破坏国家统一的；</li>
                                        <li>损害国家荣誉和利益的；</li>
                                        <li>煽动民族仇恨、民族歧视，破坏民族团结的；</li>
                                        <li>破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
                                        <li>散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
                                        <li>侮辱或者诽谤他人，侵害他人合法权益的；</li>
                                        <li>含有法律、行政法规禁止的其他内容的；</li>
                                        <li>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的。</li>
                                    </ul>
                                </li>
                                <div className="legal-reference">由于您上述活动经由N2YUN社区判断、或进行N2YUN社区相关规定所禁止的行为，可能或已对N2YUN社区造成损失的，N2YUN社区保留包括但不限于暂停服务，立即终止服务，封禁或冻结帐号，以及向您追究法律责任的权利。</div>
                            </ul>

                            <h3>2. 资源交易规则</h3>
                            <ul>
                                <li>本平台自营资源需通过<strong>余额充值购买</strong>，充值后原则上<strong>不提供退款</strong>（法定例外情形除外）；</li>
                                <li>由于本平台未开放用户自由交易且不允许此行为，非自营资源（用户分享）的所造成的交易纠纷由用户自行协商，本平台不承担其责任。</li>
                            </ul>

                            <h3>3. 网络安全规则</h3>
                            <ul>
                                <li>未经N2YUN社区书面同意，您不得对N2YUN社区服务进行包括但不限于DDoS攻击、渗透、破解等可能扰乱服务的正常运营的行为。</li>
                            </ul>
                        </section>
                    )}

                    {(currentSection === 'all' || currentSection === 'payment') && (
                        <section id="payment">
                            <h2>四、充值条款</h2>
                            <h3>1. 余额充值</h3>
                            <ul>
                                <li>充值金额用于购买会员服务或自营资源，一但成功充值之后, 是<strong>不可提现、不可转让</strong>的。</li>
                                {/* <li>充值视为您知晓且同意《网络交易管理办法》第二十条关于"虚拟货币不退换"的规定。</li> */}
                            </ul>

                            {/* <h3>2. 退款政策</h3>
                            <ul>
                                <li><strong>非必要不退款</strong>，以下情形除外：
                                    <ul>
                                        <li>资源无法正常下载或服务未提供（需提交证明）；</li>
                                        <li>账户被非法盗用导致消费；</li>
                                    </ul>
                                </li>
                                <li>会员服务到期前未使用的部分不支持退款。</li>
                            </ul> */}
                            {/* <div className="payment-visual">
                                <div className="balance-card">
                                    <div className="card-header">账户余额</div>
                                    <div className="card-balance">¥ 0.00</div>
                                    <div className="card-action">立即充值</div>
                                </div>
                                <div className="refund-notice">
                                    <div className="notice-icon">!</div>
                                    <p>充值后原则上不提供退款服务</p>
                                </div>
                            </div> */}
                        </section>
                    )}

                    {(currentSection === 'all' || currentSection === 'privacy') && (
                        <section id="privacy">
                            <h2>五、隐私与个人信息保护</h2>
                            <h3>1. 信息收集范围</h3>
                            <ul>
                                <li><strong>必要信息</strong>：手机号、账号密码、设备标识符（用于安全风控）；</li>
                                <li><strong>可选信息</strong>：头像、昵称（如您提供）；</li>
                                {/* <li className="legal-reference">依据《个人信息保护法》第十三条，基于履行合同必需处理信息可不单独征得同意。</li> */}
                            </ul>

                            <h3>2. 信息使用与共享</h3>
                            <ul>
                                <li>手机号用于身份验证、安全登录及重大通知；</li>
                                <li><strong>未经您同意，不会向第三方提供个人信息</strong>，除非：
                                    <ul>
                                        <li>应司法机关要求；</li>
                                        <li>为应对公共安全事件。</li>
                                    </ul>
                                </li>
                            </ul>

                            <h3>3. 用户权利保障</h3>
                            <ul>
                                <li>您有权<strong>查询、更正、删除个人信息</strong>，或撤回已同意的授权；</li>
                                {/* <li>注销账号后，我们将<strong>删除或匿名化您的数据</strong>。</li> */}
                            </ul>
                        </section>
                    )}

                    {/* 其他部分由于篇幅限制在此省略，实际实现中需要完整展示 */}

                    <div className="agreement-footer">
                        <div className="important-note">
                            <h3>重要提示</h3>
                            {/* <ul>
                                <li>本协议引用《常见类型移动互联网应用程序必要个人信息范围规定》（2021年）第五条，明确实用工具类社区论坛<strong>无需通讯录、地理位置等非必要信息</strong>；</li>
                                <li>隐私政策全文见<a href="#">N2YUN社区隐私政策链接</a>。</li>
                            </ul> */}
                            <p><strong>注册或登录及使用本平台服务即代表您已充分理解并接受上述用户协议。</strong></p>
                        </div>




                        {/* <div className="agreement-actions">
                            <div className="agreement-checkbox">
                                <input
                                    type="checkbox"
                                    id="agree"
                                    checked={isAgreed}
                                    onChange={() => setIsAgreed(!isAgreed)}
                                />
                                <label htmlFor="agree">我已阅读并同意N2YUN社区用户协议</label>
                            </div>
                            <button
                                className="agree-button"
                                disabled={!isAgreed}
                                onClick={handleAgree}
                            >
                                同意并继续
                            </button>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserAgreement